import { EnumSchema, FromSchema, Partial, Replace } from '@40seas/entities/common';
import { string, z } from 'zod';
import { BuyerRoles, SupplierRoles, UserRole } from './user.role.enum';

export const UserInviteSchema = z.object({
    email: z.string().email(),
    roles: z.array(EnumSchema(UserRole)).min(1),
    buyers: z.array(string()).optional(),
    sendInvitation: z.boolean().optional(),
    tenants: z.array(string()).optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    isOwner: z.boolean().optional(),
    inviterEmail: z.string().optional(),
    inviterName: z.string().optional(),
});

export class UserInvite extends FromSchema(UserInviteSchema) {
    email: string;
    roles: UserRole[];
    buyers?: string[];
    sendInvitation?: boolean;
    tenants?: string[];
    firstName?: string;
    lastName?: string;
    isOwner?: boolean;
    inviterEmail?: string;
    inviterName?: string;
}

export class UserSuppliersInvite extends Partial(
    Replace(UserInvite, [
        {
            fieldName: 'roles',
            newFieldSchema: z.array(EnumSchema(SupplierRoles)),
        },
    ]),
) {}

export class UserBuyersInvite extends Partial(
    Replace(UserInvite, [
        {
            fieldName: 'roles',
            newFieldSchema: z.array(EnumSchema(BuyerRoles)),
        },
    ]),
) {}
